import apiWrapper from 'Helpers/apiWrapper'
// import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getIntegrationsByTag: (lang, tag) => `${baseURL}/lang/${lang}/tag/${tag}`
  }
})(process.env.BEICATALOG_URL)

export const getIntegrationsByTag = (lang, tag) => {
  const url = endpoints.getIntegrationsByTag(lang, tag)
  return apiWrapper({
    method: 'get',
    url
  }).then((res) => res.data)
}
